import {Injectable} from '@angular/core';
import {environment} from '../../../../environments/environment';
import {HttpClient, HttpParams} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class CoverService {
  private baseUrl = "apiCoverUrl/omnis/cover-importer";

  constructor(private http: HttpClient) {
  }


  getCover(type: string, id: string, isbn) {
        const params = new HttpParams().set('isbn', isbn);
        return this.http.get(this.baseUrl +  '/api/cover/isbn/cover', { params: params, responseType: 'blob'});
  }
}
